<ion-content>
  <div class="store-payment-wrapper" id="productScroll">
    @if (stepperIndex == 0) {
      <div class="store-payment-top">
        <img src="assets/icon/back_arrow.png" alt="Back arrow" class="back-ic" (click)="handleExitIntentPopup()" />
        <h1 class="checkout-heading">{{ "store-payment.Checkout" | translate }}</h1>
        <p class="select-payment">{{ "store-payment.Select payment" | translate }}</p>
      </div>
    }
    @if (stepperIndex == 1) {
      <div class="store-summary-top">
        <h1 class="checkout-heading">{{ "store-payment.Order confimation" | translate }}</h1>
      </div>
    }
    <mat-horizontal-stepper labelPosition="bottom" [selectedIndex]="stepperIndex" #stepper
      class="payment-stepper store-checkout-payment" [linear]="true">
      <mat-step [completed]="isPaymentDone">
        <ng-template matStepLabel>{{ "store-payment.Payment" | translate }}</ng-template>
        @if (paymentDetails$ | async; as storedCards) {
          <div class="wallet-type">
            @if (purchaseDetail?.page === 'topUp') {
              <div>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ "store-payment.Top up" | translate }}</p>
                  <p class="purchase-content">{{ purchaseDetail?.real_name }}</p>
                  @if (purchaseDetail?.line) {
                    <p class="purchase-content">{{ purchaseDetail?.line }}
                    {{ "store-payment.Line(s)" | translate }}</p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'store') {
              <div>
                <ion-card class="purchase-card">
                  @if (!checkout_description) {
                    <p class="purchase-heading">{{ purchaseDetail?.selectedDay?.length * (purchaseDetail?.line + 1) }} {{
                      "store-payment.Lines" | translate }}, {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}
                    </p>
                  }
                  <ng-container>
                    <p class="purchase-content">
                      @if (checkout_description) {
                        <p [innerHTML]="checkout_description | safeHtml | translate"></p>
                      } @else {
                        {{ purchaseDetail?.line + 1 }} {{ (purchaseDetail?.line > 1 ? "store-payment.Lines" :
                        "store-payment.line") |
                        translate }} {{ ('dynamic_value.'+ purchaseDetail?.real_name) | translate }}
                        @for (day of purchaseDetail?.selectedDay; track day; let i = $index) {
                          <span>
                            @if (i > 0) {
                              <span>, </span>
                            }
                            {{ ('dynamic_value.'+(day | day) | translate) }}
                          </span>
                        }
                        @if (customOfferCashbackText) {
                          <span>{{' + ' + customOfferCashbackText}}</span>
                        }
                      }
                    </p>
                  </ng-container>
                  @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type === 'subscription') {
                    <p class="purchase-content"
                      >
                      {{ "store-payment.flexible_membership" | translate }}
                    </p>
                  }
                  @if (purchaseDetail?.selectedDay?.length > 0 && purchaseDetail?.selectedDiscount?.type === 'oneoff') {
                    <p class="purchase-content"
                      >
                      {{ purchaseDetail?.selectedDiscount?._title?.[selectedLanguage || "en"] ||
                      purchaseDetail?.selectedDiscount?.title }}
                    </p>
                  }
                  @if (purchaseDetail?.offers?.no_weeks > 1 && purchaseDetail?.offers?.no_weeks < 100) {
                    <p class="purchase-content"
                      >
                      {{ "store-payment.For" | translate }} {{ ' ' + purchaseDetail?.offers?.no_weeks }}
                      {{ "store-payment.weeks" | translate }}
                    </p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'offerDay') {
              <div>
                <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  @for (desc of purchaseDetail?.offers?.description; track desc) {
                    <p class="purchase-content">{{ desc }}</p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'offerOfDay' && purchaseDetail?.offers?.description?.length > 0) {
              <div>
                <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name}}</p>
                  @for (desc of purchaseDetail?.offers?.description; track desc) {
                    <p class="purchase-content" [innerHTML]="desc | safeHtml"></p>
                  }
                </ion-card>
              </div>
            }
            <!-- [UI] Update Addons Section start -->
            @if (upsellList?.length > 0 && purchaseDetail?.p_type === 21) {
              <div class="upsell-container">
                <h4>{{ "payment.addons-title" | translate }}</h4>
                @for (addOnList of upsellList; track addOnList; let i = $index) {
                  <ion-row class="splitter-line-bottom">
                    <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="checkbox-area">
                      <ion-checkbox mode="ios" color="secondary" [value]="addOnList?.price[preferredCurrency]"
                        (ionChange)="checkBoxChanged($event, addOnList)">
                      </ion-checkbox>
                    </ion-col>
                    <ion-col size="8" size-md="10" size-lg="10" size-xl="10" class="details"
                      [innerHTML]="addOnList?.html_msg[selectedLanguage] | safeHtml">
                    </ion-col>
                    <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="price">
                      <strong> {{currencySymbol}}{{addOnList?.price[preferredCurrency]}} </strong>
                    </ion-col>
                  </ion-row>
                }
              </div>
            }
            @if (purchaseDetail?.page === 'syndicate') {
              <div>
                <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  <p class="purchase-content">{{ totalLine }} {{ "store-payment.total" | translate }}</p>
                  @for (product of purchaseDetail?.products; track product) {
                    <div>
                      <span class="Checkoutdescriptionheading"> {{ product.product_name }}
                      {{ "store-payment.Line(s)" | translate }}</span>
                      @for (drawday of product.draw_day_group; track drawday) {
                        @if (purchaseDetail.type === 'ongoing') {
                          @if (product.line_count > 1) {
                            <div class="Checkoutdescription">
                              {{ product.line_count }} {{ "store-payment.lines every" | translate }} {{ drawday }}
                            </div>
                          }
                          @if (product.line_count == 1) {
                            <div class="Checkoutdescription">
                              {{ product.line_count }} {{ "store-payment.lines every" | translate }} {{ drawday }}
                            </div>
                          }
                        }
                        @if (purchaseDetail?.type === 'oneoff') {
                          @if (product.line_count > 1) {
                            <div class="Checkoutdescription">
                              {{ product.line_count }} {{ "store-payment.lines comming" | translate }} {{ drawday }}
                            </div>
                          }
                          @if (product.line_count == 1) {
                            <div class="Checkoutdescription">
                              {{ product.line_count }} {{ "store-payment.lines comming" | translate }} {{ drawday }}
                            </div>
                          }
                        }
                      }
                    </div>
                  }
                  @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
                    <p class="purchase-heading purchase-offer">{{ selectedOffer?.title }}</p>
                    <p class="purchase-content">{{ selectedOffer?.extract }}</p>
                  }
                </ion-card>
              </div>
            }
            @if (purchaseDetail?.page === 'voucher') {
              <div>
                <h1 class="purchase-title">{{ "store-payment.Purchase" | translate }}</h1>
                <ion-card class="purchase-card">
                  <p class="purchase-heading">{{ purchaseDetail?.real_name }}</p>
                  <p class="purchase-content">{{ purchaseDetail?.offers.description }}</p>
                </ion-card>
              </div>
            }
            <!-- <ion-item lines="none" class="card-data ion-no-padding" *ngFor="let card of storedCards; let i = index"
            [hidden]="!showAll && i > 2">
            <ion-row class="">
              <ion-col size="3" class="image-column">
                <img [src]="card?.card_image" alt="{{ card?.card_type }}" class="card-image" />
              </ion-col>
              <ion-col size="6" class="card-number">**** **** **** {{ card.card_short_number }}</ion-col>
              <ion-col size="3" class="checkbox-area">
                <ion-checkbox class="select-method-checkbox" color="secondary" [(ngModel)]="card.isChecked"
                (ngModelChange)="changeCheckCard(storedCards, i)"></ion-checkbox>
              </ion-col>
            </ion-row>
          </ion-item> -->
          @if (!slideToBuyBtnStatus) {
          <ion-item lines="none" class="card-data ion-no-padding" [hidden]="!showAll && i > 2">
            <ion-radio-group [(ngModel)]="selectedCardData" class="card-radio-group" mode="md">
              @for (card of storedCards.slice(0, 2); track card; let i = $index) {
                @if (card) {
                  <ion-row class="">
                    <ion-col size="3" class="image-column">
                      <img [src]="card?.card_image" alt="{{ card?.card_type }}" class="card-image" />
                    </ion-col>
                    <ion-col size="6" class="card-number">*** *** **** {{ card?.card_short_number }}</ion-col>
                    <ion-col size="3" class="checkbox-area">
                      <ion-item lines="none">
                        <!-- <ion-radio slot="end" color="secondary" [value]="card?.id" class="ion-radio"></ion-radio> -->
                        <ion-checkbox mode="ios" class="select-method-checkbox" [value]="card?.id" color="secondary"
                        [(ngModel)]="card.isChecked" (ngModelChange)="changeCheckCard(storedCards, i)"></ion-checkbox>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                }
              }
            </ion-radio-group>
          </ion-item>
          <!-- <ion-item lines="none" *ngIf="storedCards?.length > 2 && !showAll">
          <div class="add-payment-wrapper" style="width: 100%; justify-content: flex-end">
            <p class="add-payment-method" (click)="showAll = true">{{ "store-payment.View All" | translate }}</p>
          </div>
        </ion-item> -->
        <!--Master card-->
        <ion-item>
          <ion-label>{{ "store-payment.payment_type" | translate }}</ion-label>
          <ion-select [value]="selectedCard" #selectCard (ionChange)="onChange(selectCard.value)">
            <ion-select-option value="10">{{ "store-payment.visa" | translate }}</ion-select-option>
            <ion-select-option value="15">{{ "store-payment.master_card" | translate }}</ion-select-option>
          </ion-select>
        </ion-item>
        <!--Master card-->
        <ion-item lines="none">
          <div class="add-payment-wrapper" style="width: 100%; justify-content: flex-end">
            @if (!addNewCardInProgress) {
              <p (click)="addNewCard()" class="add-payment-method">
                {{ "store-payment.card" | translate }}
              </p>
            }
            @if (addNewCardInProgress) {
              <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
              style="color: blue; margin-right: 1vh"></ion-spinner>
            }
          </div>
        </ion-item>
      }
      </div>
    } @else {
      <app-in-progress-animation></app-in-progress-animation>
    }

    <!-- [UI] vouchers slider -->
    @if (checkoutVoucherService.vouchers$ | async; as vouchers) {
     @if (checkoutVoucherService.discountVouchersStatus && vouchers?.length) {
      <div class="vouchers-slider-wrapper">
        <h3 class="block-title">{{ "store-payment.Available_vouchers" | translate }}</h3>
        <swiper [config]="storeSliderOptions1">
          @for (voucher of vouchers; track voucher) {
          <ng-template swiperSlide>
            <div class="vouchers-slide" [class.used-voucher]="voucher.isUsed"
              [class.voucher-slide-full]="voucher?.isSelected === false">
              <span class="sub-title">-{{ voucher.discount_percentage }}% {{ voucher?.supplier?.toLowerCase() !==
                "general" ? voucher?.supplier?.toUpperCase() : "" }}</span>
              <p class="amount">{{ voucher?.changeExpiryText ? ("store-payment.Expires" | translate) :
                ("store-payment.Expires_in" | translate) }} <app-count-down-timer class="remaining-time"
                  end="{{voucher?.expiry_date?.seconds}}" type="seconds"></app-count-down-timer>
              </p>
                <ion-checkbox mode="ios" class="voucher-checkbox" role="checkbox" [(ngModel)]="voucher.isSelected"
                  (ionChange)="onVoucherSelect($event, voucher,typeOfVoucher())" [disabled]="voucher.isDisabled"
                  labelPlacement="end" [attr.data-applied-text]="'store-payment.applied' | translate"></ion-checkbox>
                <div class="voucher_hand_tap">
                  @if(!(checkoutVoucherService.isAnyVoucherChecked$ | async)) {
                  <ng-lottie class="hand_tap_animation"
                    [options]="{ path : '../../../../assets/tap-animation.json' }"></ng-lottie>
                  }
                </div>
            </div>
          </ng-template>
          }
        </swiper>
      </div>
    }
  }
  <!-- [UI] vouchers slider -->

  <div class="payable-today-wrapper">
    <p class="payable-today">{{ "store-payment.Payable" | translate }}</p>
    @if (purchaseDetail?.selectedDiscount) {
      <div>
        @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
          <p class="payable-today-amt">
            <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{ currencySymbol }}{{ (purchaseDetail?.prize +
            this.updatedPrizeValue) | displayCurrency }}</span> @if (selectedDiscountValue > 0) {
            <span>{{ currencySymbol }}{{
              (purchaseDetail?.prize + this.updatedPrizeValue - ((purchaseDetail?.prize + this.updatedPrizeValue) *
            selectedDiscountValue)) | displayCurrency }}</span>
          }
        </p>
      }
      @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
        <p class="payable-today-amt">
          {{ currencySymbol }}{{ (purchaseDetail?.prize + this.updatedPrizeValue) | displayCurrency }}/wk
        </p>
      }
    </div>
  } @else {
    <div>
      @if (purchaseDetail?.page !== 'offerOfDay') {
        <p class="payable-today-amt">
          {{ currencySymbol }}{{ (purchaseDetail?.prize + this.updatedPrizeValue) | displayCurrency
          }}{{ purchaseDetail?.type === "ongoing" ? "/wk" : "" }}
        </p>
      }
      @if (purchaseDetail?.page === 'offerOfDay') {
        <p class="payable-today-amt">
          {{ currencySymbol }}{{ (purchaseDetail?.preferred_currency?.prize + this.updatedPrizeValue) | displayCurrency }}
          @if (purchaseDetail?.type !== 'one-off') {
            <span>/wk</span>
          }
        </p>
      }
    </div>
  }

</div>

@if (slideToBuyBtnStatus) {
  <app-slide-to-pay
    #slideToPay
    [disabled]="!getCheckCardDetailId()"
    [buttonTextKey]="buttonText"
    (activated)="onSlideToPayActivated()"
  ></app-slide-to-pay>
} @else {
@if (!purchaseDetail?.isCreatingPS) {
  <ion-button size="small " expand="block" class="pay-btn"
    (click)="proceedToPay(stepper); startSpinner()" [hidden]="isPaymentDone"
    [disabled]="!getCheckCardDetailId() || spinnerAnimation">
    @if (!spinnerAnimation && proceed) {
      <mat-icon class="lock-icon">{{ "store-payment.lock" | translate }}</mat-icon>
      {{ "store-payment.Pay now" | translate }}
    }
    @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
        </mat-progress-spinner>
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
    }
    @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
    }
  </ion-button>
} @else {
  <ion-button size="small" expand="block" class="pay-btn" (click)="proceedToPayForPS(stepper); startSpinner()"
    [hidden]="isPaymentDone" [disabled]="!getCheckCardDetailId() || spinnerAnimation">
    @if (!spinnerAnimation && proceed) {
      <mat-icon class="lock-icon">{{ "store-payment.lock" | translate }}</mat-icon>
      {{ "store-payment.Pay now" | translate }}
    }
    @if (spinnerAnimation) {
      <div class="spinners">
        <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
        </mat-progress-spinner>
        <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
        </mat-progress-spinner>
      </div>
    }
    @if (!proceed) {
      <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
    }
  </ion-button>
}
}
<p class="bottom-info">
  {{ "store-payment.Hatchster" | translate }}
</p>
</mat-step>
<mat-step>
  <ng-template matStepLabel>{{ "store-payment.Summary" | translate }}</ng-template>
  <div class="checkout-summary">
    <ion-card class="brought-card">
      <p class="brought-card-heading">{{ "store-payment.bought" | translate }}</p>
      <div class="brought-card-content-wrap">
        @if (purchaseDetail?.page === 'topUp') {
          <p class="brought-card-title">
            {{ "store-payment.Top up" | translate }}
          </p>
        }
        @if (!checkout_description) {
          <p class="brought-card-title">
            {{ purchaseDetail?.real_name }} {{purchaseDetail?.page === 'topUp' ? '' : 'Lines'}}
          </p>
        }
        @if (purchaseDetail?.page === 'syndicate') {
          <div>
            <p class="brought-card-title">{{ purchaseDetail?.real_name }}</p>
            <p class="brought-card-content">{{ totalLine }} Line(s) in total</p>
            @for (product of purchaseDetail?.products; track product) {
              <p class="line-heading">{{ product?.product_name }}</p>
              @for (draw_day_group of product.draw_day_group; track draw_day_group) {
                @if (purchaseDetail.type === 'ongoing') {
                  <p class="brought-card-content">
                    @if (product?.line_count > 1) {
                      <span>{{ product?.line_count }}
                        {{ "store-payment.lines every" | translate }}
                      {{ draw_day_group }}</span>
                    }
                    @if (product?.line_count == 1) {
                      <span>{{ product?.line_count }}
                        line every
                      {{ draw_day_group }}</span>
                    }
                  </p>
                }
                @if (purchaseDetail?.type === 'oneoff') {
                  <p class="brought-card-content">
                    @if (product.line_count > 1) {
                      <span>{{ product.line_count }}
                      {{ "store-payment.lines comming" | translate }} {{ draw_day_group }}</span>
                    }
                    @if (product.line_count == 1) {
                      <span>
                        {{ product.line_count }} {{ "store-payment.lines comming" | translate }}
                      {{ draw_day_group }}</span>
                    }
                  </p>
                }
              }
            }
            @for (selectedOffer of purchaseDetail?.selectedOffers; track selectedOffer) {
              <p class="line-heading">{{ selectedOffer?.title }}</p>
              <p class="line-content">{{ selectedOffer?.extract }}</p>
            }
          </div>
        }

        @if (purchaseDetail?.page === 'offerDay') {
          <div>
            @if (checkout_description) {
              <p [innerHTML]="checkout_description | safeHtml | translate"></p>
            } @else {
              @for (desc of purchaseDetail?.offers?.description; track desc) {
                <p class="lines-total offerDay-desc">{{ desc }}</p>
              }
            }
          </div>
        }

        @if (purchaseDetail?.page === 'store') {
          <div>
            @if (checkout_description) {
              <p [innerHTML]="checkout_description | safeHtml | translate"></p>
            } @else {
              @for (day of purchaseDetail?.selectedDay; track day) {
                <p class="lines-total offerDay-desc">{{ purchaseDetail?.line + 1 }}
                  {{ "store-payment.lines" | translate }} {{ ('dynamic_value.'+(day | day) | translate) }}
                  @if (customOfferCashbackText) {
                    <span>{{' + ' + customOfferCashbackText}}</span>
                  }
                </p>
              }
            }
          </div>
        }

        @if (purchaseDetail?.page === 'voucher') {
          <div>
            <p class="line-content">{{ purchaseDetail?.offers.description }}</p>
          </div>
        }

        @if (purchaseDetail?.page === 'topUp') {
          <div></div>
        }

        <!-- UI for showing upsell options summary -->
        @if (upsellSummaryArray && upsellSummaryArray.length > 0) {
          <div class="upsell-checkout-summary">
            @for (addOn of upsellSummaryArray; track addOn) {
              @if (addOn.product_description === 'award' && addOn?.summary_content) {
                <div>
                  <p class="brought-card-title">
                    {{ "add-card.Top up" | translate }}
                  </p>
                  <p class="brought-card-content">
                    {{ currencySymbol + addOn.summary_content?.amount?.[preferredCurrency] + ' ' +
                    addOn.summary_content?.real_name + ' ' + addOn?.summary_content?.sub_label?.[selectedLanguage] }}
                  </p>
                </div>
              }
              @if (addOn.product_description === 'offer' && addOn?.summary_content) {
                <div>
                  <p class="brought-card-title">
                    {{ addOn.summary_content?.real_name }} {{'add-card.Lines'|translate}}
                  </p>
                  @for (day of addOn.summary_content?.selected_day; track day) {
                    <p class="lines-total offerDay-desc">{{ addOn.summary_content?.line + 1 }}
                      {{ "store-payment.lines" | translate }} {{ ('dynamic_value.'+(day | day) | translate) }}
                    </p>
                  }
                </div>
              }
            }
          </div>
        }

        <ion-row class="card-price-wrap">
          <ion-col>
            <p class="card-price">{{ "store-payment.Price" | translate }}</p>
          </ion-col>
          <ion-col class="card-price-value-wrap">
            @if (purchaseDetail?.selectedDiscount) {
              <div>
                @if (purchaseDetail?.selectedDiscount?.type !== 'subscription') {
                  <p class="card-price-value">
                    <span [ngClass]="{'strikethrough-grayed': selectedDiscountValue > 0}"> {{ currencySymbol }}{{ (purchaseDetail?.prize +
                    this.updatedPrizeValue) | displayCurrency }}</span> @if (selectedDiscountValue > 0) {
                    <span>{{ currencySymbol }}{{
                      (purchaseDetail?.prize + this.updatedPrizeValue - ((purchaseDetail?.prize + this.updatedPrizeValue) *
                    selectedDiscountValue)) | displayCurrency }}</span>
                  }
                </p>
              }
              @if (purchaseDetail?.selectedDiscount?.type == 'subscription') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency }}/wk
                </p>
              }
            </div>
          } @else {
            <div>
              @if (purchaseDetail?.page !== 'offerOfDay') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{ (purchaseDetail?.prize + (updatedPrizeValue || 0)) | displayCurrency
                  }}{{ purchaseDetail?.type === "ongoing" ? "/wk" : "" }}
                </p>
              }
              @if (purchaseDetail?.page === 'offerOfDay') {
                <p class="card-price-value">
                  {{ currencySymbol }}{{(purchaseDetail?.preferred_currency?.prize + (updatedPrizeValue || 0)) |
                  displayCurrency }}
                  @if (purchaseDetail?.type !== 'one-off') {
                    <span>/wk</span>
                  }
                </p>
              }
          </div>
        }

      </ion-col>
    </ion-row>
  </div>
  @if (purchaseDetail?.draw) {
    <ion-row class="start-day-wrapper">
      <ion-col>
        <p class="start-date">{{ "store-payment.Start date" | translate }}</p>
      </ion-col>
      <ion-col class="start-day-wrap">
        <p class="start-day">{{ ('dynamic_value.'+(purchaseDetail?.draw | day) | translate) }}</p>
      </ion-col>
    </ion-row>
  }
</ion-card>
<ion-button (click)="openTickets()" class="view-ticket-btn">
  @if (purchaseDetail.page == 'topUp') {
    <span>{{ "store-payment.Back to store" | translate }} </span>
  }
  @if (purchaseDetail.page != 'topUp') {
    <span>{{ "store-payment.View ticket" | translate }} </span>
  }
</ion-button>
</div>
</mat-step>

<ng-template matStepperIcon="edit">
  <mat-icon>done</mat-icon>
</ng-template>
</mat-horizontal-stepper>
@if (stepperIndex == 1) {
  <ion-row class="list-wrapper-background">
    <div class="jackpot-items">
      <ion-item lines="none" class="total-list-container">
        <ion-grid class="ion-no-padding splitter-line">
          <ion-row>
            <swiper class="store-slider-trigger" [config]="storeSliderOptions2" #slider
              (swiper)="setSwiperInstance($event)">
              @for (item of promotions; track item; let i = $index) {
                <ng-template swiperSlide>
                  <div class="jpt-banner" [ngClass]="{'card-gray':cardOfferDisabled(i)}"
                    [ngStyle]="{'background': item.background}">
                    <div class="overlay-2 single-overlay">
                      <div class="adjusted-column-sizes">
                        <div class="column-70">
                          <div class="card-title">
                            <h5>{{item.jackpot_value}}</h5>
                            <p [innerHTML]="item.content.description" class="card-desc"></p>
                          </div>
                          <ion-button class="card-cta"
                            (click)="!cardOfferDisabled(i) ? cardOfferPayment(item, i) : null"
                            [disabled]="cardOfferDisabled(i)">
                            <p [innerHTML]="item.content.cta_label"></p>
                          </ion-button>
                        </div>
                        <div class="column-40">
                          <p class="timer">{{item.content.expiry_label}}<br>{{expiry_in_minutes}}:{{seconds}}</p>
                          <div class="image-wrapper">
                            <img alt="Lottery icon" src="{{item.image_url}}" />
                          </div>
                        </div>
                      </div>
                      <!-- Processing Indicator -->
                      @if (processingStates[i]) {
                        <div class="processing-overlay">
                          <div class="spinner"></div>
                          <p>Processing...</p>
                        </div>
                      }
                    </div>
                  </div>
                </ng-template>
              }
            </swiper>
            <ion-row class="my-custom-pager">
              <ion-col class="pager-2">
                <button (click)="prev()" class="nav-prev-icon-euro">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </button>
              </ion-col>
              <ion-col size="auto" class="pager-2">
                <div class="swiper-pagination swiper-pagination-2"></div>
              </ion-col>
              <ion-col class="pager-2">
                <button (click)="next()" class="nav-next-icon-euro">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </button>
              </ion-col>
            </ion-row>
          </ion-row>
        </ion-grid>
      </ion-item>
    </div>
  </ion-row>
}
</div>
</ion-content>
